import { getStatusColor } from 'src/entities/RoadAccident'
import { roadAccidentsEnumLabels } from '~/shared/config/constants'
import { TMS_DOMAIN } from '~/shared/config/env'
import { AsyncGridColumns, ColumnDate, ColumnLink } from '~/shared/ui/AsyncGrid'
import { ChipStatus } from '~/shared/ui/Chips'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.number',
    field: 'number',
    minWidth: 160,
    renderCell: ({ row }) => <ColumnLink to={row.id}>{row.number}</ColumnLink>,
  },
  {
    headerName: 'column.date',
    field: 'createdAt',
    sortable: false,
    minWidth: 180,
    renderCell: ({ value }) => <ColumnDate value={value} type='date' />,
  },
  {
    headerName: 'column.plate number',
    field: 'carPlateNumber',
    sortable: false,
    minWidth: 180,
    renderCell: ({ row }) => (
      <ColumnLink href={`${TMS_DOMAIN}cars/${row.carExtId}`}>
        {row.carPlateNumber}
      </ColumnLink>
    ),
  },
  {
    headerName: 'column.brand and model',
    field: 'carBrandModel',
    sortable: false,
    minWidth: 210,
  },
  {
    headerName: 'column.mileage',
    field: 'mileage',
    sortable: false,
    minWidth: 120,
  },
  {
    headerName: 'column.subdivision',
    field: 'carSubdivision',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.status',
    field: 'status',
    sortable: false,
    minWidth: 180,
    renderCell: ({ row }) => {
      return (
        <ChipStatus
          labelI18n={roadAccidentsEnumLabels[row.status]}
          variant={getStatusColor(row.status)}
        />
      )
    },
  },
  {
    headerName: 'column.responsible',
    field: 'responsible',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.driver',
    field: 'driverFullName',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.car status',
    field: 'carStatus',
    sortable: false,
    minWidth: 180,
  },
  {
    headerName: 'column.repair order',
    field: 'repairOrder',
    sortable: false,
    minWidth: 180,
    renderCell: ({ value }) => {
      return (
        <ChipStatus
          variant={value ? 'green' : 'red'}
          labelI18n={value ? 'column.yes' : 'column.no'}
        />
      )
    },
  },
]
